import React from "react";
import ClickToCopyWrapper from "../common/ClickToCopyWrapper";
import UnitHasChildrenModal from "./UnitHasChildrenModal";

class UnitHasChildrenButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  render() {
    const { isModalOpen } = this.state;
    const { unit, networkId, networkName, isLabelOnly = false } = this.props;

    const childUnits = unit.child_units || unit.childUnits || [];

    return (
      <>
        <div
          className={`flex items-center gap-1 ${
            isLabelOnly ? "" : "cursor-pointer"
          }`}
        >
          <span
            className={`font-bold text-blue-700 ${
              isLabelOnly ? "" : "hover:underline"
            }`}
            onClick={() => {
              if (isLabelOnly) return;
              this.setState({ isModalOpen: true });
            }}
          >
            Parent of {childUnits.length}
          </span>
          <ClickToCopyWrapper
            copyText={childUnits.join(", ")}
            tooltipMessage="Click to copy child unit IDs"
          ></ClickToCopyWrapper>
        </div>

        {isModalOpen && !isLabelOnly && (
          <UnitHasChildrenModal
            unit={unit}
            networkId={networkId}
            networkName={networkName}
            handleClose={() => this.setState({ isModalOpen: false })}
          ></UnitHasChildrenModal>
        )}
      </>
    );
  }
}

export default UnitHasChildrenButton;
